import React, { useState } from 'react'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

const ImageGallery = ({ images }) => {
  const [photoIndex, setIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const renderImages = () => {
    let photoIndex = -1;

    const handleImageClick = (privateKey) => {
      setIndex(privateKey)
      setIsOpen(true)
    }

    const handleKeyPress = (event, privateKey) => {
      if (event.key === "Enter") {
        handleImageClick(privateKey);
      }
    }


    return images.map(imageSrc => {
      photoIndex++;
      const privateKey = photoIndex;
      return (
        <div
          key={imageSrc}
          role="button"
          tabIndex={0}
          style={{
            display: 'inline-block',
            width: images.length > 1 ? 'calc(33% - 15px)' : '100%',
            marginRight: '15px',
            cursor: 'zoom-in'
          }}
          onKeyDown={(event) => handleKeyPress(event, privateKey)}
          onClick={() => handleImageClick(privateKey)}
        >
          <img src={imageSrc} alt="Gallery" style={{ width: '100%' }} />
        </div>
      );
    })

  }
  return (
    <div>
      <div className="mdb-lightbox no-margin">
        {renderImages()}
      </div>
      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          imageTitle={photoIndex + 1 + "/" + images.length}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setIndex((photoIndex + images.length - 1) % images.length)}
          onMoveNextRequest={() => setIndex((photoIndex + 1) % images.length)}
        />
      )}
    </div>
  );
}


export default ImageGallery;
